import { API_ENDPOINTS, useQuery } from "utilities";

const CategoryQuery = (shop_id) => {
    const { data, isLoading, isError } = useQuery(`${API_ENDPOINTS.CATEGORIES}?shop=${shop_id}`)
   
    return {
        categories: data || [],
        isLoading,
        isError
    }



}

export default CategoryQuery

